import React from 'react';
import { TextareaAutosize as InputField, TextareaAutosizeProps } from '@material-ui/core';

function TextArea({ ...props }: TextareaAutosizeProps) {
  return <InputField color="primary" {...props} style={{ resize: 'none' }} />;
}

export default TextArea;
